import type { DripsyColor } from "@utils";
import { useDripsyColor } from "@utils";
import * as React from "react";
import Svg, { Path } from "react-native-svg";

function PlusIcon({ size, color }: { size: number; color: DripsyColor }) {
  const finalColor = useDripsyColor({ color });
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24">
      <Path fill={finalColor} d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
    </Svg>
  );
}
export default PlusIcon;
